import { render, staticRenderFns } from "./PsAdministrationTransactionsDetail.vue?vue&type=template&id=6be1a485&scoped=true&"
import script from "./PsAdministrationTransactionsDetail.vue?vue&type=script&lang=js&"
export * from "./PsAdministrationTransactionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PsAdministrationTransactionsDetail.vue?vue&type=style&index=0&id=6be1a485&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be1a485",
  null
  
)

export default component.exports